/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Render_RequiredInputs */



/**
* | output |
* | --- |
* | "Render Required" |
*
* @param {Editor_Filter_Render_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_render_required = /** @type {((inputs?: Editor_Filter_Render_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Render_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Render Required")
	if (locale === "de") return /** @type {LocalizedString} */ ("Render Required")
	if (locale === "it") return /** @type {LocalizedString} */ ("Render Required")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Render Required")
	if (locale === "es") return /** @type {LocalizedString} */ ("Render Required")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Render Required")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Render Required")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Render Required")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Render Required")
	return /** @type {LocalizedString} */ ("Render Required")
});